/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Message_PlaceholderInputs */

const cs_chat_message_placeholder = /** @type {(inputs: Chat_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napište zprávu…`)
};

const en_chat_message_placeholder = /** @type {(inputs: Chat_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a message…`)
};

/**
* | output |
* | --- |
* | "Write a message…" |
*
* @param {Chat_Message_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_message_placeholder = /** @type {((inputs?: Chat_Message_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Message_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_message_placeholder(inputs)
	return cs_chat_message_placeholder(inputs)
});